export interface FiltersVisitasI {
  idEmpreendimento: string;
  dataDe: Date | null;
  dataAte: Date | null;
}

export const defaultFiltersVisitas = {
  idEmpreendimento: "",
  dataDe: null,
  dataAte: null,
};
